import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  FaComments,
  FaBullhorn,
  FaLightbulb,
  FaUsers,
  FaSearch,
  FaPlus,
} from "react-icons/fa";

import Sidebar from "../pages/Community/Sidebar";
import PostComposer from "../pages/Community/PostComposer";
import PostCard from "../pages/Community/PostCard";
import RightSidebar from "../pages/Community/RightSidebar";

import {
  getCommunityPosts,
  createCommunityPost,
  createCommunityComment,
  likeCommunityPost,
  toggleCommunityPin,
} from "../services/communityService";

export default function CommunityPage() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [search, setSearch] = useState("");
  const [showComposer, setShowComposer] = useState(false);
  const [posts, setPosts] = useState([]);
const bottomRef = useRef(null);
  // ==========================
  // LOAD POSTS
  // ==========================

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    try {
      const data = await getCommunityPosts();

      setPosts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Kunde inte hämta inlägg", error);
    }
  };


  // ==========================
  // CREATE POST
  // ==========================

  const createPost = async (data) => {
  try {

    const post = await createCommunityPost({
      title: data.title,
      text: data.text,
      category: data.category,
      type: data.type,

      // filkoppling
      documentId:
        data.documentId ??
        null,

    });


    setPosts((prev) => [
      ...prev,
      post
    ]);


  } catch (error) {

    console.error(
      "Kunde inte skapa inlägg",
      error
    );

  }
};

  // ==========================
  // LIKE
  // ==========================

  const likePost = async (id) => {
    try {
      const updated = await likeCommunityPost(id);

      setPosts((prev) =>
        prev.map((post) => (post.id === id ? updated : post))
      );
    } catch (error) {
      console.error("Kunde inte gilla inlägg", error);
    }
  };

  // ==========================
  // PIN
  // ==========================

  const togglePin = async (id) => {
    try {
      const updated = await toggleCommunityPin(id);

      setPosts((prev) =>
        prev.map((post) => (post.id === id ? updated : post))
      );
    } catch (error) {
      console.error("Kunde inte fästa inlägg", error);
    }
  };

  // ==========================
  // COMMENT
  // ==========================

  const addComment = async (id, text) => {
    try {
      const comment = await createCommunityComment({
        postId: id,
        text,
      });

      setPosts((prev) =>
        prev.map((post) =>
          post.id === id
            ? {
                ...post,
                comments: [...(post.comments || []), comment],
              }
            : post
        )
      );
    } catch (error) {
      console.error("Kunde inte spara kommentar", error);
    }
  };

  // ==========================
  // FILTER POSTS
  // ==========================

  const filteredPosts = useMemo(() => {
    return posts.filter((post) => {
      const categoryMatch =
        selectedCategory === "all" ||
        post.category === selectedCategory;

      const text = `${post.title} ${post.text} ${post.author}`.toLowerCase();

      const searchMatch = text.includes(search.toLowerCase());

      return categoryMatch && searchMatch;
    });
  }, [posts, selectedCategory, search]);

useEffect(() => {
  bottomRef.current?.scrollIntoView({
    behavior: "smooth",
  });
}, [filteredPosts]);
  // ==========================
  // MENU
  // ==========================

  const menu = [
    {
      key: "all",
      title: "Alla inlägg",
      icon: <FaComments />,
    },
    {
      key: "important",
      title: "Viktigt",
      icon: <FaBullhorn />,
    },
    {
      key: "tips",
      title: "Tips",
      icon: <FaLightbulb />,
    },
    {
      key: "social",
      title: "Socialt",
      icon: <FaUsers />,
    },
  ];

    return (
    <div className="bg-[#F8FAFA] py-8">
      <div className="mx-auto max-w-7xl px-6">

        {/* HEADER */}
        <div className="mb-8 flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-3xl font-semibold tracking-tight text-neutral-900">
              Dialogforum
            </h1>

            <p className="mt-2 max-w-2xl text-neutral-600">
              Ställ frågor, dela erfarenheter och kommunicera med
              projektets medarbetare.
            </p>
          </div>

          <button
            onClick={() => setShowComposer(true)}
            className="
              inline-flex
              items-center
              gap-2
              rounded-xl
              bg-[#3BAFA3]
              px-5
              py-3
              font-medium
              text-white
              transition
              hover:bg-[#32998d]
            "
          >
            <FaPlus />
            Nytt inlägg
          </button>
        </div>

        {/* LAYOUT */}
        <div className="grid gap-6 lg:grid-cols-12">

          {/* VÄNSTER SIDOFÄLT */}
          <aside className="lg:col-span-3">
            <div className="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm">
              <Sidebar
                active={selectedCategory}
                onNavigate={setSelectedCategory}
                posts={posts}
                menu={menu}
              />
            </div>
          </aside>

          {/* MITTEN */}
          <main className="space-y-6 lg:col-span-6">

            {/* SÖK */}
            <div className="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm">
              <div className="flex items-center gap-3 rounded-xl border border-neutral-200 px-4 py-3">

                <FaSearch className="text-neutral-400" />

                <input
                  type="text"
                  placeholder="Sök efter inlägg..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="
                    flex-1
                    bg-transparent
                    outline-none
                    placeholder:text-neutral-400
                  "
                />

              </div>
            </div>

            {/* SKAPA INLÄGG */}
            {showComposer && (
              <div className="rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm">
                <PostComposer
                  onSubmit={async (post) => {
                    await createPost(post);
                    setShowComposer(false);
                  }}
                />
              </div>
            )}

            {/* INLÄGG */}
           {filteredPosts.length === 0 ? (
  <div className="rounded-2xl border border-dashed border-neutral-300 bg-white p-12 text-center">
    <FaComments className="mx-auto mb-4 text-4xl text-neutral-300" />

    <h3 className="text-lg font-semibold text-neutral-800">
      Inga inlägg hittades
    </h3>

    <p className="mt-2 text-neutral-500">
      Prova att ändra sökningen eller skapa ett nytt inlägg.
    </p>
  </div>
) : (
  <div
    className="
      h-[70vh]
      overflow-y-auto
      space-y-5
      pr-2
    "
  >
    {filteredPosts.map((post) => (
      <PostCard
        key={post.id}
        post={post}
        onLike={likePost}
        onPin={togglePin}
        onComment={addComment}
      />
    ))}

    <div ref={bottomRef} />
  </div>
)}
          </main>

          {/* HÖGER SIDOFÄLT */}
          <aside className="lg:col-span-3">
            <div className="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm">
              <RightSidebar
                posts={posts}
                events={[
                  {
                    id: 1,
                    title: "APT",
                    date: "Måndag 09:00",
                  },
                  {
                    id: 2,
                    title: "Planeringsmöte",
                    date: "Onsdag 13:00",
                  },
                  {
                    id: 3,
                    title: "Workshop",
                    date: "Fredag 10:00",
                  },
                ]}
              />
            </div>
          </aside>

        </div>
      </div>
    </div>
  );
}